import { useSessionStore } from '@/stores/SessionStore.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';

export const setContentProtectionAction = async (enabled: boolean) => {
    if (!window.electronApi) {
        return;
    }

    const sessionStore = useSessionStore();

    sessionStore.isContentProtectionEnabled = enabled;
    window.electronApi.setContentProtection(enabled);

    if (enabled) {
        createTextToast(
            `Content protection has been enabled,`,
            'The desktop app is now fully hidden.',
            'success',
            true,
        );
    } else {
        createTextToast(
            `Content protection has been disabled.`,
            'The desktop app is now fully visible to all other software, be careful.',
            'destructive',
            true,
        );
    }
};
